import axios from "../axios";
import { presignUploadUrl } from "./urls";

// The S3 bucket is private and the browser holds no AWS credentials. The
// backend issues a short-lived presigned POST for each file; the file goes
// straight to S3 with it.
//
// uploadFile resolves with the same shape the old aws-s3 client returned, so
// callers keep using `res.location`. `location` is a CloudFront URL (or a
// presigned S3 URL where no CDN is configured): it can be shown right away,
// and the backend stores it as the permanent S3 URL when it is sent back in a
// create/update request.
const uploadFile = async file => {
  const { data } = await axios.post(presignUploadUrl, {
    file_name: file.name || "upload",
    content_type: file.type,
  });
  const upload = data.data;

  const formData = new FormData();
  Object.entries(upload.fields).forEach(([key, value]) =>
    formData.append(key, value)
  );
  // S3 requires the file to be the last field.
  formData.append("file", file);

  const response = await fetch(upload.upload_url, {
    method: "POST",
    body: formData,
  });
  if (!response.ok) {
    throw new Error(`S3 upload failed with status ${response.status}`);
  }

  return {
    bucket: upload.upload_url,
    key: upload.key,
    location: upload.file_url,
  };
};

export const S3Client = { uploadFile };
